import React from "react";
import {Column, Row} from "react-vcomponents";
import {BoxController, ShowMessageBox} from "react-vmessagebox";
import {AddActivity} from "../../Server/Commands/ActivityCommands.js";
import {Activity} from "../../Server/DB/activities/@Activity.js";
import {ActivityDetailsUI, ActivityDetailsUI_Ref} from "../../UI/Activities/ActivityDetailsUI.js";

export function ShowAddActivityDialog() {
	let newActivity = new Activity({name: "", color: "128,128,128,1"});

	let detailsUI: ActivityDetailsUI_Ref|n;
	let error: string|n;
	const Change = (..._)=>boxController.UpdateUI();
	const boxController: BoxController = ShowMessageBox({
		title: `Add activity`, cancelButton: true,
		message: ()=>{
			boxController.UpdateOptions({okButtonProps: {enabled: error == null}});
			return (
				<Column style={{width: 600}}>
					<ActivityDetailsUI ref={c=>void(detailsUI = c)} baseData={newActivity} forNew={true}
						onChange={val=>Change(newActivity = val, error = detailsUI!.GetValidationError())}/>
					{error && error != "Please fill out this field." && <Row mt={5} style={{color: "rgba(200,70,70,1)"}}>{error}</Row>}
				</Column>
			);
		},
		onOK: ()=>{
			new AddActivity({entry: newActivity}).RunOnServer();
		},
	});
}